<template>
  <div class="mx-4 mb-4">
    <div class="mb-3 mt-4">
      <span class="main-title">RIDER SUMMARY | &nbsp;</span>
      <span class="submain-title">Extra credit zone report</span>
      <download-excel
        :data="export_extra_credit_zone_format"
        :fields="{
              'No': 'No',
              'Order code' : 'order_code',
              'Date' :  'date' ,
              'Rider':  'rider',
              'Remark':  'remark',
              'Point' :  'point',
              'Note' : 'note' 
            }"
        :name="'ExtraCreditZoneReport_'+search_config.datetime_start+'_to_'+search_config.datetime_end+'.xls'"
        style="position:absolute;top:0px;right:40px;"
      >
        <v-btn icon class="icon-print">
          <v-icon large color="black">print</v-icon>.xls
        </v-btn>
      </download-excel>
      <download-excel
        type="csv"
        :data="export_extra_credit_zone_format"
        :fields="{
              'No': 'No',
              'Order code' : 'order_code',
              'Date' :  'date' ,
              'Rider':  'rider',
              'Remark':  'remark',
              'Point' :  'point',
              'Note' : 'note' 
            }"
        :name="'ExtraCreditZoneReport_'+search_config.datetime_start+'_to_'+search_config.datetime_end+'.csv'"
        style="position:absolute;top:0px;right:150px;"
      >
        <v-btn icon class="icon-print">
          <v-icon large color="black">print</v-icon>.csv
        </v-btn>
      </download-excel>
    </div>
    <SearchRiderName />
    <ExtraCreditZoneReportList />
  </div>
</template>

<script>
import SearchRiderName from "@/components/back-office/Report/SearchBar/SearchRiderName";
import ExtraCreditZoneReportList from "@/components/back-office/Report/ExtraCreditZoneReportList";
import { mapState } from "vuex";
export default {
  data() {
    return {
      items: [
        "Sort by revenue Max to Min",
        "Sort by revenue Min to Max",
        "Sort by store name"
      ]
    };
  },
  components: {
    ExtraCreditZoneReportList,
    SearchRiderName
  },
  destroyed() {
    this.$store.commit("fetchExtraCreditReport/resetState");
  },
  computed: {
    ...mapState({
      search_config: state => state.fetchExtraCreditReport.clone_config_path,
      export_extra_credit_zone_format: state =>
        state.fetchExtraCreditReport.export_extra_credit_zone_format
    })
  },
  mounted() {
    const path = [
      {
        text: "Select province",
        disabled: false,
        href: "/weserve_admin_login/select/"
      },
      {
        text: "Select service",
        disabled: false,
        href: "/weserve_admin_login/control/" + this.$route.params.province
      },
      {
        text: "Dashboard report",
        disabled: false,
        href:
          "/weserve_admin_login/control/" +
          this.$route.params.province +
          "/report/main_dashboard"
      },
      {
        text: "Extra credit zone report",
        disabled: true,
        href:
          "/weserve_admin_login/control/" +
          this.$route.params.province +
          "/report/extra_credit_zone_report"
      }
    ];
    this.$store.commit("backOffice/saveRecentRoute", path);
  }
};
</script>

<style scoped>
.main-title {
  font-size: 22px;
  font-weight: bold;
}
.submain-title {
  font-size: 20px;
  color: #707070;
}
.icon-print {
  margin-top: 65px;
}
</style>
